import { IApplicationState } from '../../types';

export const getPublicState = (state: IApplicationState) => state.public;
